export const SET_USER_INFO = "SET_USER_INFO";
export const SET_USER_LABO = "SET_USER_LABO";
export const SET_USER_TOKEN = "SET_USER_TOKEN";
